import { useMemo } from 'react';

export type ClubMemberStatusTypes =
  | 'valid-membership'
  | 'expired-membership'
  | 'membership-will-expire';

export enum MembershipStatus {
  VALID = 1,
  EXPIRED = 0,
  WILL_EXPIRE = 2,
}

export const useClubMemberStatus = (
  isPartnerLeague: boolean = false,
  isRegistrationOnlyForMembers: boolean,
  firstPlayerMembershipStatus: number,
  secondPlayerMembershipStatus?: number
): ClubMemberStatusTypes => {
  return useMemo(() => {
    if (!isRegistrationOnlyForMembers) {
      return 'valid-membership';
    }

    if (isPartnerLeague && secondPlayerMembershipStatus !== MembershipStatus.VALID) {
      return 'expired-membership';
    }

    switch (firstPlayerMembershipStatus) {
      case MembershipStatus.VALID:
        return 'valid-membership';
      case MembershipStatus.EXPIRED:
        return 'expired-membership';
      case MembershipStatus.WILL_EXPIRE:
        return 'membership-will-expire';
      default:
        return 'valid-membership';
    }
  }, [
    isPartnerLeague,
    isRegistrationOnlyForMembers,
    firstPlayerMembershipStatus,
    secondPlayerMembershipStatus,
  ]);
};
